import BaseAPI from "../api";

const path: string = "/visa-form";

// export type listType = {
//   keyword?: number;
//   limit?: number;
//   page?: number;
// };

export class VisaFormApi extends BaseAPI {
  static list(query: any): Promise<any> {
    return this.api.get(`${path}`, {
      params: { ...query },
    });
  }
  static dropdown(query: any): Promise<any> {
    return this.api.get(`${path}/dropdown`, {
      params: { ...query },
    });
  }
  static post(body: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }
  static patch(body: any, id: any): Promise<any> {
    return this.api.patch(`${path}/${id}`, body);
  }
  static status(body: any, id: any): Promise<any> {
    return this.api.patch(`${path}/${id}/status`, body);
  }
  static findById(id: any): Promise<any> {
    return this.api.get(`${path}/${id}`);
  }
  static delete(id: any): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }
  static deleteFile(id: any, id_visa_form_file: any): Promise<any> {
    return this.api.delete(`${path}/${id}/file/${id_visa_form_file}`);
  }
  static file(id: any, body: any): Promise<any> {
    return this.api.post(`${path}/${id}/file`, body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}
